export default class PixController {
  constructor(resource) {
    this._resource = resource;
  }

  sendPix(data) {
    return this._resource('pix')
      .save(data)
      .then(res => res.data);
  }
}
